/* ============================================================
   CPFS — recipe category filter
   ------------------------------------------------------------
   Secondary, client-side filter for the Meals / Snacks / Beverages
   landing pages (sections/cpfs-recipe-category.liquid). Clicking a
   featured-SKU chip shows only the recipe cards whose data-skus list
   contains that product handle; "All" shows every card. No reload,
   no scroll jump.

   A <recipe-category-filter> custom element hosts the behaviour, so
   it re-initialises cleanly whenever the section re-renders in the
   theme editor (a fresh element runs connectedCallback again). It is
   null-guarded and, without JS or custom-element support, every card
   stays visible (the CSS gives the element display:block on its own).
   Filtered-in cards get `is-revealed` so the shared reveal-on-scroll
   layer (cpfs.js) never leaves them stuck at opacity:0.
   ============================================================ */

(function () {
  'use strict';

  if (!('customElements' in window) || customElements.get('recipe-category-filter')) return;

  function revealItem(item) {
    // The reveal gate lives on descendants (the card) and possibly the item.
    if (item.hasAttribute('data-reveal')) item.classList.add('is-revealed');
    var gated = item.querySelectorAll('[data-reveal]');
    for (var i = 0; i < gated.length; i++) gated[i].classList.add('is-revealed');
  }

  customElements.define(
    'recipe-category-filter',
    class RecipeCategoryFilter extends HTMLElement {
      connectedCallback() {
        if (this._bound) return;
        this._bound = true;

        this.filterBar = this.querySelector('[data-recipe-filter]');
        this.items = Array.prototype.slice.call(this.querySelectorAll('.v3-recipe-filter-item'));
        if (!this.filterBar || !this.items.length) return;

        this.chips = Array.prototype.slice.call(this.filterBar.querySelectorAll('.v3-anchor'));
        this._onClick = this.onClick.bind(this);
        this.filterBar.addEventListener('click', this._onClick);
      }

      disconnectedCallback() {
        if (this.filterBar && this._onClick) {
          this.filterBar.removeEventListener('click', this._onClick);
        }
      }

      onClick(event) {
        var chip = event.target.closest('.v3-anchor');
        if (!chip || !this.filterBar.contains(chip)) return;
        // Chips are <button>s, but preventDefault keeps this safe if they ever
        // become links and stops any incidental navigation / scroll jump.
        event.preventDefault();
        this.apply(chip);
      }

      apply(chip) {
        var sku = chip.getAttribute('data-sku') || 'all';

        for (var i = 0; i < this.chips.length; i++) {
          var isActive = this.chips[i] === chip;
          this.chips[i].classList.toggle('is-active', isActive);
          this.chips[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }

        for (var j = 0; j < this.items.length; j++) {
          var item = this.items[j];
          var haystack = ',' + (item.getAttribute('data-skus') || '') + ',';
          var show = sku === 'all' || haystack.indexOf(',' + sku + ',') !== -1;
          item.hidden = !show;
          if (show) revealItem(item);
        }
      }
    },
  );
})();
